export const ASSESSMENT_ROOT_DIV_ID = "assessment-root"
